// extracted by mini-css-extract-plugin
module.exports = {"base":"searchList_base__XNaYa","listActions":"searchList_listActions__2dAWS"};